import React from "react";
import HomePage from "./views/HomePage";
import { HomePageContextProvider } from "./HomeView";
import HomepageConstants from "../../constants/contentFile.json";

const HomePageView = () => {
  return (
    <HomePageContextProvider>
      <HomePage textContents={HomepageConstants.homepage} />
    </HomePageContextProvider>
  );
};

export default HomePageView;
